import { render, staticRenderFns } from "./queueItem.vue?vue&type=template&id=620bdade&scoped=true&"
import script from "./queueItem.vue?vue&type=script&lang=js&"
export * from "./queueItem.vue?vue&type=script&lang=js&"
import style0 from "./queueItem.vue?vue&type=style&index=0&id=620bdade&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620bdade",
  null
  
)

export default component.exports